'use strict';

exports.__esModule = true;
exports.page = exports.ON_WF_PEER_RECOMMENDATION_ACTIVE_TAB_CHANGED = exports.ON_WF_PEER_RECOMMENDATION_TABS_CHANGED = exports.ON_REVIEW_ITEM_COLOR_PICKER_TOGGLE = exports.ON_CUSTOMIZATION_PROPS_CHANGE = exports.GET_SPECIALIST_AUTOCOMPLETE = exports.GET_DIRECTORY_AUTOCOMPLETE = exports.GET_PRACTICE_AUTOCOMPLETE = exports.ON_PROFILE_TYPE_SELECTED = exports.ON_DEFAULT_TAB_SELECTED = exports.DISABLE_PROFILE_IMAGE = exports.ON_HREF_LINK_CHANGED = exports.ON_PRACTICE_SELECTED = exports.ON_MULTIPLE_PROFILE_REMOVED = exports.ON_MULTIPLE_PROFILE_SELECTED = exports.ON_PROFILE_SELECTED = exports.ON_BACKGROUND_SELECTED = exports.ON_LAYOUT_SELECTED = exports.ON_THEME_SELECTED = exports.DISABLE_BANNER = exports.DISABLE_TABS = undefined;

var _doctifyUtils = require('doctify-utils');

var _constants = require('../utils/constants');

// This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var DISABLE_TABS = exports.DISABLE_TABS = 'WIDGET_EXAMPLES:DISABLE_TABS';
var DISABLE_BANNER = exports.DISABLE_BANNER = 'WIDGET_EXAMPLES:DISABLE_BANNER';
var ON_THEME_SELECTED = exports.ON_THEME_SELECTED = 'WIDGET_EXAMPLES:ON_THEME_SELECTED';
var ON_LAYOUT_SELECTED = exports.ON_LAYOUT_SELECTED = 'WIDGET_EXAMPLES:ON_LAYOUT_SELECTED';
var ON_BACKGROUND_SELECTED = exports.ON_BACKGROUND_SELECTED = 'WIDGET_EXAMPLES:ON_BACKGROUND_SELECTED';
var ON_PROFILE_SELECTED = exports.ON_PROFILE_SELECTED = 'WIDGET_EXAMPLES:ON_PROFILE_SELECTED';
var ON_MULTIPLE_PROFILE_SELECTED = exports.ON_MULTIPLE_PROFILE_SELECTED = 'WIDGET_EXAMPLES:ON_MULTIPLE_PROFILE_SELECTED';
var ON_MULTIPLE_PROFILE_REMOVED = exports.ON_MULTIPLE_PROFILE_REMOVED = 'WIDGET_EXAMPLES:ON_MULTIPLE_PROFILE_REMOVED';
var ON_PRACTICE_SELECTED = exports.ON_PRACTICE_SELECTED = 'WIDGET_EXAMPLES:ON_PRACTICE_SELECTED';
var ON_HREF_LINK_CHANGED = exports.ON_HREF_LINK_CHANGED = 'WIDGET_EXAMPLES:ON_HREF_LINK_CHANGED';
var DISABLE_PROFILE_IMAGE = exports.DISABLE_PROFILE_IMAGE = 'WIDGET_EXAMPLES:DISABLE_PROFILE_IMAGE';
var ON_DEFAULT_TAB_SELECTED = exports.ON_DEFAULT_TAB_SELECTED = 'WIDGET_EXAMPLES:ON_DEFAULT_TAB_SELECTED';
var ON_PROFILE_TYPE_SELECTED = exports.ON_PROFILE_TYPE_SELECTED = 'WIDGET_EXAMPLES:ON_PROFILE_TYPE_SELECTED';
var GET_PRACTICE_AUTOCOMPLETE = exports.GET_PRACTICE_AUTOCOMPLETE = 'WIDGET_EXAMPLES:GET_DIRECTORY_AUTOCOMPLETE';
var GET_DIRECTORY_AUTOCOMPLETE = exports.GET_DIRECTORY_AUTOCOMPLETE = 'WIDGET_EXAMPLES:GET_DIRECTORY_AUTOCOMPLETE';
var GET_SPECIALIST_AUTOCOMPLETE = exports.GET_SPECIALIST_AUTOCOMPLETE = 'WIDGET_EXAMPLES:GET_SPECIALIST_AUTOCOMPLETE';
var ON_CUSTOMIZATION_PROPS_CHANGE = exports.ON_CUSTOMIZATION_PROPS_CHANGE = 'WIDGET_EXAMPLES:ON_CUSTOMIZATION_PROPS_CHANGE';
var ON_REVIEW_ITEM_COLOR_PICKER_TOGGLE = exports.ON_REVIEW_ITEM_COLOR_PICKER_TOGGLE = 'WIDGET_EXAMPLES:ON_REVIEW_ITEM_COLOR_PICKER_TOGGLE';
var ON_WF_PEER_RECOMMENDATION_TABS_CHANGED = exports.ON_WF_PEER_RECOMMENDATION_TABS_CHANGED = 'WIDGET_EXAMPLES:ON_WF_PEER_RECOMMENDATION_TABS_CHANGED';
var ON_WF_PEER_RECOMMENDATION_ACTIVE_TAB_CHANGED = exports.ON_WF_PEER_RECOMMENDATION_ACTIVE_TAB_CHANGED = 'WIDGET_EXAMPLES:ON_WF_PEER_RECOMMENDATION_ACTIVE_TAB_CHANGED';

var page = {
	getDirectoryAutocomplete: function getDirectoryAutocomplete(filter, profileType) {
		return (0, _doctifyUtils.createAction)({
			url: 'directory/autocomplete',
			method: 'GET',
			parameters: { filter: filter, records: 5, types: profileType + 's' },
			actionType: _constants.PRACTICE_PROFILE_TYPE === profileType && GET_PRACTICE_AUTOCOMPLETE || _constants.SPECIALIST_PROFILE_TYPE === profileType && GET_SPECIALIST_AUTOCOMPLETE || null,
			keyword: 'matching_items'
		});
	},
	onPracticeSelected: function onPracticeSelected(practice) {
		return {
			type: ON_PRACTICE_SELECTED,
			practice: practice
		};
	},
	onDefaultTabSelected: function onDefaultTabSelected(defaultTab) {
		return {
			type: ON_DEFAULT_TAB_SELECTED,
			defaultTab: defaultTab
		};
	},
	onProfileTypeSelected: function onProfileTypeSelected(profileType) {
		return {
			type: ON_PROFILE_TYPE_SELECTED,
			profileType: profileType
		};
	},
	onProfileSelected: function onProfileSelected(profile) {
		return {
			type: ON_PROFILE_SELECTED,
			profile: profile
		};
	},
	onLayoutSelected: function onLayoutSelected(layout) {
		return {
			type: ON_LAYOUT_SELECTED,
			layout: layout
		};
	},
	onBackgroundSelected: function onBackgroundSelected(background) {
		return {
			type: ON_BACKGROUND_SELECTED,
			background: background
		};
	},
	disableBanner: function disableBanner(_disableBanner) {
		return {
			type: DISABLE_BANNER,
			disableBanner: _disableBanner
		};
	},
	disableProfileImage: function disableProfileImage(_disableProfileImage) {
		return {
			type: DISABLE_PROFILE_IMAGE,
			disableProfileImage: _disableProfileImage
		};
	},
	disableTabs: function disableTabs(_disableTabs) {
		return {
			type: DISABLE_TABS,
			disableTabs: _disableTabs
		};
	},
	onThemeSelected: function onThemeSelected(theme) {
		return {
			type: ON_THEME_SELECTED,
			theme: theme
		};
	},
	onHrefLinkChanged: function onHrefLinkChanged(hrefLink) {
		return {
			type: ON_HREF_LINK_CHANGED,
			hrefLink: hrefLink
		};
	},
	setCustomizationProps: function setCustomizationProps(customizations) {
		return {
			type: ON_CUSTOMIZATION_PROPS_CHANGE,
			payload: { customizations: customizations }
		};
	},
	setWfPeerRecommendationTabs: function setWfPeerRecommendationTabs(tabs) {
		return {
			type: ON_WF_PEER_RECOMMENDATION_TABS_CHANGED,
			tabs: tabs
		};
	},
	setWfPeerRecommendationActiveTab: function setWfPeerRecommendationActiveTab(tab) {
		return {
			type: ON_WF_PEER_RECOMMENDATION_ACTIVE_TAB_CHANGED,
			tab: tab
		};
	},
	toggleReviewItemColorPicker: function toggleReviewItemColorPicker(toggleState) {
		return {
			type: ON_REVIEW_ITEM_COLOR_PICKER_TOGGLE,
			payload: {
				displayReviewItemColorPicker: toggleState
			}
		};
	},
	onMultipleProfileSelected: function onMultipleProfileSelected(profile) {
		return {
			type: ON_MULTIPLE_PROFILE_SELECTED,
			profile: profile
		};
	},
	onMultipleProfileRemoved: function onMultipleProfileRemoved(profileId) {
		return {
			type: ON_MULTIPLE_PROFILE_REMOVED,
			profileId: profileId
		};
	}
};
exports.page = page;